export default __webpack_public_path__ + "static/media/landing_2.b6b76f84.jpg";